import { createTheme } from "@mui/material";

// Theme colors that can be easily modified
export const backgroundColors = {
    mainYellow: '#FFDD00',
    lightYellow: '#FFF5B8',
    orange: '#FD8000',
    darkBackground: '#222222',
};

// Define the theme colors
export const themeColors = {
    mainYellow: backgroundColors.mainYellow,
    lightYellow: backgroundColors.lightYellow,
    orange: backgroundColors.orange,
    darkBackground: backgroundColors.darkBackground,
    blue: '#3C68A9', // Darker blue for buttons and highlights
    darkBlue: '#2A4979', // Even darker blue for hover states
    lightBlue: '#E7F8FD', // Light blue for backgrounds
    paperYellow: '#FDF5BD',
    red: '#EB4F2F'
};

// Create a theme instance
export const theme = createTheme({
    palette: {
        primary: {
            main: themeColors.orange, // Use orange for primary actions like buttons
        },
        secondary: {
            main: themeColors.mainYellow, // Yellow as secondary color
        },
        info: {
            main: '#1976d2', // Keep a standard blue for info
        },
        background: {
            default: '#FFFFFF', // White background
            paper: themeColors.paperYellow, // White paper background
        },
        text: {
            primary: themeColors.darkBackground,
            secondary: 'rgba(34, 34, 34, 0.7)', // Semi-transparent dark for secondary text
        },
    },
    typography: {
        fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        h1: {
            fontWeight: 700,
            fontSize: '2.5rem',
        },
        h2: {
            fontWeight: 600,
            fontSize: '2rem',
        },
        h3: {
            fontWeight: 600,
            fontSize: '1.75rem',
        },
        h4: {
            fontWeight: 600,
            fontSize: '1.5rem',
        },
        h5: {
            fontWeight: 500,
            fontSize: '1.25rem',
        },
        h6: {
            fontWeight: 500,
            fontSize: '1rem',
        },
        button: {
            textTransform: 'none', // Don't uppercase button text
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 12, // More rounded corners
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none', // Remove shadow
                    '&:hover': {
                        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.12)', // Add shadow on hover
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.08)', // Lighter shadow for papers
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.05)', // Very light shadow for app bar
                },
            },
        },
    },
});